import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Zoom
} from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';

/**
 * Componente de tarjeta de estadísticas con diseño TRACKEA
 * @param {string} titulo - Título de la estadística
 * @param {number|string} valor - Valor a mostrar
 * @param {React.ReactNode} icono - Icono a mostrar
 * @param {string} color - Color principal de la tarjeta
 * @param {string} tendencia - Texto de tendencia (opcional)
 */
const EstadisticasCard = ({ titulo, valor, icono, color, tendencia }) => (
  <Zoom in={true} timeout={500}>
    <Card sx={{
      background: `linear-gradient(135deg, ${color}15, ${color}08)`,
      border: `2px solid ${color}30`,
      borderRadius: 3,
      minHeight: 120,
      display: 'flex',
      alignItems: 'center',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: `0 12px 30px ${color}25`
      }
    }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 2 }}>
        <Avatar sx={{
          background: `linear-gradient(135deg, ${color}, ${color}CC)`,
          mr: 2,
          width: 56,
          height: 56,
          boxShadow: `0 8px 20px ${color}40`
        }}>
          {icono}
        </Avatar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h3" sx={{
            fontWeight: 'bold',
            color: color,
            mb: 0.5,
            textShadow: `0 2px 4px ${color}20`
          }}>
            {valor}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 500 }}>
            {titulo}
          </Typography>
          {tendencia && (
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
              <TrendingUpIcon sx={{ fontSize: 16, color: '#4CAF50', mr: 0.5 }} />
              <Typography variant="caption" color="success.main" sx={{ fontWeight: 'bold' }}>
                {tendencia}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  </Zoom>
);

export default EstadisticasCard;
